import {useEffect, useRef, useState} from 'react';
import {getDocumentsByPkCode} from '../api/Document.api';

export const useDocuments = (params, dependencies, afterSuccess, afterError) => {

    const [dataSource, setDataSource] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const loadDebounce = useRef(null);
    const fetchData = () => {
        loadDebounce.current = setTimeout(() => {
            if (!!params?.pkCode) {
                getDocumentsByPkCode(params, {}).then(r => {
                    setDataSource(r?.items);
                    setTotalCount(r?.totalCount);
                    setLoading(false)
                    !!afterSuccess && afterSuccess()
                }).catch((e) => {
                    setError(e);
                    setLoading(false)
                    !!afterError && afterError()
                });
            }
        }, 300);
    };

    useEffect(() => {
        setLoading(true)
        fetchData();
        return () => {
            clearTimeout(loadDebounce.current)
        }
    }, dependencies);

    return [dataSource, totalCount, loading, error];
};
